/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import {
  COUNTRYDATA_LOAD,
  COUNTRYDATA_LOAD_SUCCESS,
  COUNTRYDATA_LOAD_FAILURE,
} from "../../Constants/ActionTypes";
import { ICountryRegionData } from "../../Interfaces/SiteContent";

/**
 *
 */
export interface IGetCountryRegion {
  type: typeof COUNTRYDATA_LOAD;
}

/**
 *
 */
export interface IGetCountryRegionSuccess {
  type: typeof COUNTRYDATA_LOAD_SUCCESS;
  countryRegions: ICountryRegionData[];
}

/**
 *
 */
export interface IGetCountryRegionFailure {
  type: typeof COUNTRYDATA_LOAD_FAILURE;
  countryRegionLoadError: string;
}

/**
 *
 */
export const getCountryRegion = (): CountryRegionActionTypes => ({
  type: COUNTRYDATA_LOAD,
});

/**
 *
 * @param countryRegions
 */
export const getCountryRegionSuccess = (
  countryRegions: ICountryRegionData[]
): CountryRegionActionTypes => ({
  type: COUNTRYDATA_LOAD_SUCCESS,
  countryRegions,
});

/**
 *
 * @param errorMessage
 */
export const getCountryRegionFailure = (
  countryRegionLoadError: string
): CountryRegionActionTypes => ({
  type: COUNTRYDATA_LOAD_FAILURE,
  countryRegionLoadError,
});

export type CountryRegionActionTypes =
  | IGetCountryRegion
  | IGetCountryRegionSuccess
  | IGetCountryRegionFailure;
